<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content class="legal-modal__content">
  @if (isLoading()) {
    <div class="legal-modal__loading" aria-live="polite" aria-busy="true">
      <mat-spinner diameter="32" />
      <span class="legal-modal__loading-label">Loading…</span>
    </div>
  } @else if (hasError()) {
    <p class="legal-modal__error" role="alert">
      Could not load content. Please try again later.
    </p>
  } @else if (content()) {
    <div class="legal-modal__body" [innerHTML]="content() | markdown"></div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close class="legal-modal__close">Close</button>
</mat-dialog-actions>
